'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'duck';
var width = 512;
var height = 512;
var aliases = [129414];
var unicode = 'f6d8';
var svgPathData = 'M384 259l0-34.4c0-13.4 5.7-25 12.7-33.7 12.1-15.1 19.3-34.2 19.3-55 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 25.8 11.1 49.1 28.9 65.2 6.4 5.8 12.2 13.3 15.6 22.1l6.6 16.5-17.1 4.8-181.6 50.9-5.4 1.5-5.2-2.2-53-22.7-12.7 0 0 16c0 97.2 78.8 176 176 176l120 0c61.9 0 112-50.1 112-112 0-32-13.4-60.9-35-81.3l-5-4.7 0-6.9zM88 280l166.1-46.5 15.6-4.4c-2.1-5.2-5.3-9.9-9.3-14-.7-.7-1.4-1.4-2.2-2.1-21-19-34.1-46.5-34.1-77 0-57.4 46.6-104 104-104 54.5 0 99.3 42 103.6 95.4 13 2.7 26.4 3.3 39.7 1.7 24.9-3.1 38.5-4.8 40.7-5.1l0 20.1c0 48.6-39.4 88-88 88l-24 0 0 27c24.6 23.3 40 56.3 40 93 0 70.7-57.3 128-128 128l-120 0C86 480 0 394 0 288l0-32 32 0 56 24zm313.2-64l22.8 0c39.8 0 72-32.2 72-72l0-1.9-22.7 2.8c-13.9 1.7-27.9 1.3-41.6-1.2-1.6 21.6-9.8 41.4-22.5 57.3-3.6 4.5-6.4 9.6-8 15zM320 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-2.7 166.7c-5.8 43.4-38.5 81.1-84.7 92.6-37.8 9.4-75.9-.9-102.5-24.5l-6-5.3 10.6-12 6 5.3c22.6 20.1 55.3 29 88 20.9 39.9-10 67.8-42.4 72.7-79.2l1.1-7.9 15.9 2.1-1.1 7.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDuck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;